var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button"},[_c('span',{staticClass:"icon-button",class:{
      'icon-button--actived': _vm.isActived,
      'icon-button--hovered': _vm.isHovered,
    },style:({ 'grid-template-columns': (_vm.gap + "px auto") })},[(_vm.icon)?_c('Icon',{staticClass:"icon-button__icon",attrs:{"name":_vm.icon}}):_vm._e(),_vm._t("default")],2),(_vm.subtitle)?_c('HoverSubtitle',{staticClass:"button-subtitle",attrs:{"label":_vm.subtitle}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }